module.exports = __webpack_public_path__ + "img/avalon-high-angle.2c56ad5b.png";